import { Tag, PartyPopper } from "lucide-react";

interface CartPromoBarProps {
  hatCount: number;
}

const THRESHOLD = 3;

export function CartPromoBar({ hatCount }: CartPromoBarProps) {
  if (hatCount === 0) return null;

  const qualified = hatCount >= THRESHOLD;
  const remaining = Math.max(0, THRESHOLD - hatCount);
  const progressPct = Math.min(100, (hatCount / THRESHOLD) * 100);

  const message = qualified
    ? "A free hat is in your cart!"
    : remaining === 1
      ? "Add 1 more hat — get your 3rd FREE"
      : `Add ${remaining} more hats — get your 3rd FREE`;

  const bgClass = qualified ? "bg-[#2E5A3D]" : "bg-[#8B6F47]";
  const trackClass = qualified ? "bg-[#1F3D2A]" : "bg-[#2A1510]/30";
  const fillClass = qualified ? "bg-[#F5EFE2]" : "bg-[#F5EFE2]";

  return (
    <div className={`border-b border-[#D4CCBC] ${bgClass} px-6 py-3`}>
      <div className="flex items-center gap-2">
        {qualified ? (
          <PartyPopper className="h-4 w-4 flex-shrink-0 text-[#F5EFE2]" />
        ) : (
          <Tag className="h-4 w-4 flex-shrink-0 text-[#F5EFE2]" />
        )}
        <p className="font-ui text-xs font-bold uppercase tracking-wider text-[#F5EFE2]">
          {message}
        </p>
      </div>
      <div className={`mt-2 h-1.5 w-full overflow-hidden rounded-full ${trackClass}`}>
        <div
          className={`h-full transition-all duration-500 ${fillClass}`}
          style={{ width: `${progressPct}%` }}
        />
      </div>
    </div>
  );
}
